import createUseContext from 'constate';
import { repo } from 'index';
import { useReducer } from 'react';
import assign from 'lodash/assign';
import get from 'lodash/get';
import { createReducer } from 'helpers/reducers-helper';
import { PermissionDenied } from 'service/api-service';
import { useAppContext } from 'use-app';

export const STATE_DEPOSIT = 'deposit';
export const STATE_WITHDRAW = 'withdraw';
export const SELECTED_TAB = 'SELECTED_TAB';
export const SELECT_NEW_PAGE = 'SELECT_NEW_PAGE';
export const PERMISSION_DENIED = 'PERMISSION_DENIED';

const FETCH_TRANSACTIONS_DONE = 'FETCH_TRANSACTIONS_DONE';

const usePoints = () => {
  const PAGE_SIZE = 20;
  const initState = {
    state: STATE_DEPOSIT,
    maxCreatedAt: undefined,
    transactions: [],
    canLoadMore: true,
    pending: true,
    permissionDenied: false,
    page: 1,
    totalPage: 0,
  };

  const selectedTab = (state, payload) => {
    return {
      ...initState,
      state: payload,
    };
  };
  const fetchTransactionsDone = (state, { data, paging }) => {
    return assign({}, state, {
      transactions: data,
      page: paging.currentPage,
      totalPage: paging.totalPage,
      pending: false,
    });
  };

  const selectNewPage = (state, payload) => {
    return {
      ...initState,
      state: state.state,
      page: payload,
    };
  };

  const permissionDenied = state => assign({}, state, { permissionDenied: true, pending: false });

  const reducer = createReducer(
    {
      [SELECTED_TAB]: selectedTab,
      [FETCH_TRANSACTIONS_DONE]: fetchTransactionsDone,
      [SELECT_NEW_PAGE]: selectNewPage,
      [PERMISSION_DENIED]: permissionDenied,
    },
    initState
  );

  const [state, dispatch] = useReducer(reducer, initState);

  const fetchMochiCoinTransactions = (state, page) => {
    repo
      .fetchMochiCoinTransactions(state, page, PAGE_SIZE)
      .then(value => {
        dispatch({
          type: FETCH_TRANSACTIONS_DONE,
          payload: value,
        });
      })
      .catch(error => {
        if (error instanceof PermissionDenied) {
          dispatch({ type: PERMISSION_DENIED });
        }
      });
  };

  const { state: appState } = useAppContext();
  const subAccount = get(appState, 'me.subAccount', null);
  const orderReadable = subAccount === null ? true : get(subAccount, 'orderRead', false);

  return { state, dispatch, orderReadable, fetchMochiCoinTransactions };
};

export const usePointsContext = createUseContext(usePoints);
